<ng-container>
    <ng-content *ngIf="pacoteReserva">
        <div class="row">
            <div class="col-md-8 d-flex title">
                <h3>{{ pacoteReserva.Nome }}</h3>
            </div>
            <div class="col-md-4 d-flex align-self-center justify-content-end" [ngSwitch]="pacoteReserva.Status">
                <h6>{{ pacoteReserva?.Pacote?.Evento ? "Status do Evento" : "Status do Pacote" | translate}}:</h6>
                <span *ngSwitchCase="0" class="badge rounded-pill bg-secondary">{{"Pendente" | translate}}</span>
                <span *ngSwitchCase="1" class="badge rounded-pill bg-secondary">{{"Aguardando" | translate }}</span>
                <span *ngSwitchCase="2" class="badge rounded-pill bg-secondary">{{"Reserva Parcial" | translate}}</span>
                <span *ngSwitchCase="3" class="badge rounded-pill bg-success">{{"Reservado" | translate}}</span>
                <span *ngSwitchCase="4" class="badge rounded-pill bg-success">{{"Solicitado" | translate}}</span>
                <span *ngSwitchCase="5" class="badge rounded-pill bg-success">{{"Emitido" | translate}}</span>
                <span *ngSwitchCase="6" class="badge rounded-pill bg-success">{{"Pago" | translate}}</span>
                <span *ngSwitchCase="7" class="badge rounded-pill bg-warning text-dark">{{"Problema Técnico" | translate
                    }}</span>
                <span *ngSwitchCase="8" class="badge rounded-pill bg-warning text-dark">{{"Cancelado" |
                    translate}}</span>
                <span *ngSwitchCase="9" class="badge rounded-pill bg-warning text-dark">{{"Excluído" |
                    translate}}</span>
                <span *ngSwitchCase="10" class="badge rounded-pill bg-warning text-dark">{{"Cancelamento com Problema" |
                    translate }}</span>
            </div>
        </div>
        <div class="row">
            <div class="row">
                <div class="col-md" id="#accordion">
                    <div id="headingOne">
                        <a class="nav-link" style="cursor: pointer;padding: 0 !important;" data-bs-toggle="collapse"
                            data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne"
                            (click)="expandedDetails = !expandedDetails">
                            {{pacoteReserva?.Pacote?.Evento ? "Detalhes do Evento" : "Detalhes do Pacote" | translate}}
                            <i class="fas fa-chevron-down" *ngIf="!expandedDetails"></i>
                            <i class="fas fa-chevron-up" *ngIf="expandedDetails"></i>
                        </a>
                    </div>
                </div>
                <div class="col-md d-flex align-self-center justify-content-end">
                    <strong>{{'Ida' | translate}}&nbsp;:</strong>
                    <span>{{ pacoteReserva.Checkin | date: 'dd/MM/yyyy' }}</span>
                </div>
                <div class="col-md d-flex align-self-center justify-content-end" style="padding: 0;">
                    <strong>{{ "Volta" | translate}}&nbsp;:</strong>
                    <span>{{ pacoteReserva.Checkout | date: 'dd/MM/yyyy' }}</span>
                </div>
            </div>

            <div class="row">
                <div id="collapseOne" class="collapse collapsed" aria-labelledby="headingOne" data-parent="#accordion">
                    <div class="p-2">
                        <ul class="nav nav-tabs" id="tabInfoServico" role="tablist">
                            <li class="nav-item" role="presentation"
                                *ngFor="let inclui of pacoteReserva?.Pacote?.PacotesInclui; let x = index">
                                <button class="nav-link" [ngClass]="x == 0 ? 'active' : ''" id="tabservico{{x}}"
                                    data-bs-toggle="tab" [attr.data-bs-target]="'#tabservicox' + x" type="button"
                                    style="text-decoration: none !important;" role="tab"
                                    [attr.aria-controls]="'tabservicox' + x"
                                    [attr.aria-selected]="x == 0 ? true : false">{{inclui?.Titulo}}
                                </button>
                            </li>
                        </ul>
                        <div class="tab-content p-2 mt-2" id="tabInfoServicoContent">
                            <div *ngFor="let inclui of pacoteReserva?.Pacote?.PacotesInclui; let x = index"
                                class="tab-pane fade" id="tabservicox{{x}}" [ngClass]="x == 0 ? 'show active' : ''"
                                role="tabpanel" [attr.aria-labelledby]="'tabservico' + x"
                                [innerHTML]="inclui?.Descritivo">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" *ngFor="let hotel of pacoteReserva.Hoteis; let h = index">
            <div class="col-md-12 title" *ngIf="hotel">
                <h5>Hotel escolhido: {{ hotel.Nome }}</h5>
                <div class="row" *ngFor="let quarto of hotel.Quartos; let q = index">
                    <h6>Quarto {{quarto.Pesquisa}} selecionado: {{ quarto.Descricao }} - {{quarto.DescricaoPensao}}</h6>
                    <h6>Loc: <strong>{{ quarto.Localizador }} <span *ngIf="hotel.Agrupador" style="display: inline;">/
                                {{hotel.Agrupador}}</span></strong></h6>
                </div>
            </div>
            <div class="col-md-12 mb-3"  *ngIf="hotel.Quartos[0]?.PoliticaCancelamento">
                <details>
                <summary><strong>{{'Política de cancelamento do hotel' | translate}}</strong>
                </summary>
                <p class="text-justify" [innerHTML]="hotel.Quartos[0]?.PoliticaCancelamento">
                </p>
                </details>
            </div>
        </div>
        <div class="row">
            <div *ngIf="pacoteReserva.Aereos.length > 0">
                <div class='col-md-12 mb-3 mt-3'>
                    <h5 class="col-md-5">{{"Aéreo(s) Incluído(s)"}}</h5>
                </div>
                <div *ngFor="let aereo of pacoteReserva.Aereos">
                    <div class="all aereo-card">
                        <div class="bodyContent">
                            <div class="seguimentosGrouperNormal">
                                <div *ngFor="let seguimento of aereo.Seguimentos; let i = index" class="seguimento">
                                    <div class="ida" *ngIf="i % 2 == 0">
                                        <div *ngFor="let voo of seguimento.Voos; let k = index">
                                            <div class='row jc-se'>
                                                <div class='col-2 as-c'>
                                                    <img src="assets/img/cias/{{voo.CiaMarketing}}.png"
                                                        alt="{{voo.CiaMarketing}}" title="{{aereo.CiaValidadora}}" />
                                                </div>
                                                <div class='col-2'>
                                                    <p
                                                        *ngIf="k == 0 || (k > 0 && voo.AeroportoPartida == seguimento.Voos[k - 1].AeroportoChegada)">
                                                        {{ voo.AeroportoPartida }}</p>
                                                    <p *ngIf="k > 0 && voo.AeroportoPartida != seguimento.Voos[k - 1].AeroportoChegada"
                                                        style="color:red">{{ voo.AeroportoPartida }}*</p>
                                                    <p style="font-size: 13px;font-weight: bold;">
                                                        {{ voo.DataPartida | date : 'dd/MM/yyyy HH:mm'}}</p>
                                                </div>
                                                <div class='col-4 text-center center'>
                                                    <div class='col voo-detalhes'>
                                                        <p>{{"Voo" | translate}} N°{{voo.NumeroVoo}} | {{"Classe" |
                                                            translate}}:
                                                            {{voo.ClasseTarifaria}} | {{"Bag." | translate}}:
                                                            {{seguimento.BagagemQuantidade}}
                                                            | {{seguimento.FamiliaTarifaria}}</p>
                                                        <app-trecho-simbol></app-trecho-simbol>
                                                    </div>
                                                </div>
                                                <div class='col-2'>
                                                    <p>{{ voo.AeroportoChegada }}</p>
                                                    <p style="font-size: 13px;font-weight: bold;">
                                                        {{voo.DataChegada | date : 'dd/MM/yyyy HH:mm'}}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="volta" *ngIf="(i % 2 != 0)">
                                        <div class='row jc-sb'>
                                            <div class='col-2'>
                                                <i class="fas fa-plane-arrival"></i>
                                            </div>
                                            <div class='col-2'>
                                                <p>Volta</p>
                                            </div>
                                            <div class='col text-end'>
                                            </div>
                                        </div>

                                        <div *ngFor="let voo of seguimento.Voos; let k = index">
                                            <div class='row jc-se'>
                                                <div class='col-2 as-c'>
                                                    <img src="assets/img/cias/{{voo.CiaMarketing}}.png"
                                                        alt="{{voo.CiaMarketing}}" title="{{aereo.CiaValidadora}}" />
                                                </div>
                                                <div class='col-3'>
                                                    <p
                                                        *ngIf="k == 0 || (k > 0 && voo.AeroportoPartida == seguimento.Voos[k - 1].AeroportoChegada)">
                                                        {{ voo.AeroportoPartida }}</p>
                                                    <p *ngIf="k > 0 && voo.AeroportoPartida != seguimento.Voos[k - 1].AeroportoChegada"
                                                        style="color:red">{{ voo.AeroportoPartida }}*</p>
                                                    <p style="font-size: 13px;font-weight: bold;">
                                                        {{ voo.DataPartida | date : 'dd/MM/yyyy HH:mm'}}</p>
                                                </div>
                                                <div class='col-3 text-center'>
                                                    <div class='col voo-detalhes'>
                                                        <p>{{voo.Duracao.substring(0,5)}}</p>
                                                        <app-trecho-simbol></app-trecho-simbol>
                                                    </div>
                                                </div>
                                                <div class='col-2'>
                                                    <p>{{ voo.AeroportoChegada }}</p>
                                                    <p style="font-size: 13px;font-weight: bold;">
                                                        {{voo.DataChegada | date : 'dd/MM/yyyy HH:mm'}}</p>
                                                </div>
                                            </div>

                                            <div class='row'>
                                                <div class='col'>
                                                    {{'Voo' | translate}} N°{{voo.NumeroVoo}} | {{"Classe" |
                                                    translate}}:
                                                    {{voo.ClasseTarifaria}} | {{"Bag." | translate}}:
                                                    {{seguimento.BagagemQuantidade}} |
                                                    {{seguimento.FamiliaTarifaria
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="pacoteReserva.Servicos.length > 0">
                <div class="col-md-8">
                    <h3>{{"Serviços Inclusos" | translate}}</h3>
                </div>
                <div class="row border-bottom" *ngFor="let servicoPacote of pacoteReserva.Servicos">
                    <div class="col-md-9 mt-3 pb-2">
                        <h5 class="text-muted">{{ servicoPacote.Titulo }}
                            <span
                                *ngIf="servicoPacote?.ExtraIntegracao2?.CategoriaServico">({{servicoPacote?.ExtraIntegracao2?.CategoriaServico}})</span>
                            <span *ngIf="empresaId != null">({{servicoPacote.Fornecedor}})</span>
                        </h5>
                    </div>



                    <div class="col-md-12 d-flex mb-2">
                        <div class="col-md-2 d-flex" *ngIf="servicoPacote?.Localizador?.length > 2">
                            <strong>{{"Loc" | translate}}:&nbsp;</strong> {{servicoPacote.Localizador}}
                        </div><br>
                        <!-- <div class="col-md d-flex" *ngIf="usuario.EmpresaId != null"><strong>{{"Fornecedor" | translate}}</strong>&nbsp; {{servicoPacote.Fornecedor}} </div>   -->
                        <div class="col-md-3 d-flex"><strong>{{"Cidade" | translate}}:</strong>&nbsp;
                            {{servicoPacote.Cidade?.Nome}} </div>
                        <div class="col-md-3 d-flex"><strong>{{"Dt. Inclusão" | translate}}</strong>&nbsp;
                            {{servicoPacote.Alteracoes.CriadoEm | date:'dd/MM/yyyy'}} </div>
                        <div class="col-md-3 d-flex" *ngIf="servicoPacote.PrazoCancelamentoWs">
                            <strong>{{"P. Cancelamento" | translate}}</strong>&nbsp;
                            {{servicoPacote.PrazoCancelamentoWs | date :'dd/MM/yyyy'}}
                        </div>
                        <div class="col-md-3 d-flex" *ngIf="servicoPacote.CodigoCliente != null">
                            <strong>{{"Código do Cliente" | translate}}</strong>&nbsp;
                            {{servicoPacote.Alteracoes.CriadoEm | date :'dd/MM/yyyy'}}
                        </div>
                        <!-- <div class="col-md d-flex">{{servicoPacote.Adt}} <strong>&nbsp;{{"Adulto" | translate}}(s)</strong></div>
                              <div class="col-md d-flex">{{servicoPacote.Chd}} <strong>&nbsp;{{'Criança' | translate}}(s)</strong></div> -->
                        <!-- <div class="col-md-2 d-flex"><strong>{{"Valor Serviço" | translate}}</strong>: {{servicoPacote.MoedaListagem.Sigla}} {{servicoPacote.ValorListagem | currency:'BRL':'':'2.2-2'}}</div> -->
                    </div>

                    <div class="col-md-12 p-2 m-2">
                        <h6 class="text-justify">{{"Descrição do Serviço" | translate}}</h6>
                        <p class="text-justify card-text p-2 mb-2" [innerHTML]="servicoPacote.Descricao">
                        </p>
                    </div>

                    <div class="accordion col-md-4" id="accordionPerguntas"
                        *ngIf="servicoPacote.Perguntas && servicoPacote.Perguntas.length > 0">
                        <div class="accordion-item">
                            <div class="accordion-header" id="headingPerguntas">
                                <a data-bs-toggle="collapse" class="nav-link accordion-button collapsed"
                                    style="cursor: pointer" data-bs-target="#collapsePerguntas" aria-expanded="false"
                                    aria-controls="collapsePerguntas">
                                    Perguntas <i class="fas fa-chevron-down"></i>
                                </a>
                            </div>
                            <div id="collapsePerguntas" class="accordion-collapse collapse"
                                aria-labelledby="headingPerguntas" data-bs-parent="#accordionPerguntas">
                                <div class="accordion-body">
                                    <div class="mt-4 row"
                                        *ngIf="servicoPacote.Perguntas && servicoPacote.Perguntas.length > 0">
                                        <div class="col col-md-3" *ngFor="let pergunta of servicoPacote.Perguntas">
                                            <h6>{{pergunta.Pergunta}}</h6>
                                            <p>R: {{pergunta.Resposta}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12"
                        *ngIf="servicoPacote.PoliticaCancelamento != '' || servicoPacote.PoliticaCancelamento != null">
                        <details>
                            <summary><strong>{{'Política de Cancelamento' | translate}}</strong>
                            </summary>
                            <p class="text-justify" [innerHTML]="servicoPacote.PoliticaCancelamento">
                            </p>
                        </details>
                    </div>
                </div>
            </div>
            <div class="row mb-3 mt-3">
                <div class="col">
                    <p>{{"Adicionado em" | translate}}: {{ pacoteReserva?.Alteracoes?.CriadoEm | date:'dd/MM/yyyy'}}</p>
                </div>
            </div>
            <div class="col text-end">

            </div>
            <div class="row">
                <div class="col text-end">
                    <strong>{{"Total" | translate}}: </strong>
                    <strong class="price">{{ pacoteReserva?.MoedaFechamento?.Sigla }} {{
                        pacoteReserva._ValorTotalFechamento | currency:'BRL':'':'2.2-2'}}</strong>
                </div>
            </div>
            <div class="col text-end" *ngIf="!cardSimplificado">
                <button class="btn btn-outline-danger" *ngIf="pacoteReserva.Status == 0 || pacoteReserva.Status == 8"
                    (click)="removerPacoteReserva(pacoteReserva.Id)">{{ "Excluir" | translate}}</button>

                <button *ngIf="pacoteReserva.Status == 3 && statusOrcamento !== 6" class="btn btn-outline-danger"
                    (click)="modalCancela.open()">{{ "Cancelar" | translate}}</button>
                <button *ngIf="pacoteReserva.Status == 0" type="button" class="btn btn-success"
                    (click)="validaSePodeReservar()">Reservar</button>

                <button *ngIf="pacoteReserva.Status == 3 && statusOrcamento === 6" type="button" class="btn btn-success"
                    (click)="imprimirVoucherEmitter.emit(pacoteReserva)" [disabled]="!liberarVoucher">
                    <span *ngIf="!liberarVoucher" class="fas fa-exclamation-circle"></span>
                    <span *ngIf="liberarVoucher" class="fas fa-check-circle"></span>
                    {{liberarVoucher ? 'Voucher' : 'Voucher Pendente'}}
                </button>
            </div>
        </div>
    </ng-content>
    <div class="row" *ngIf="mensagensSucessoPacote?.length > 10">
        <div class="alert alert-success alert-dismissible" style="width: 100%">
            <a class="close" data-bs-dismiss="alert" (click)="mensagensSucessoPacote = ''"
                aria-label="close">&times;</a>
            <ul>
                <li>{{mensagensSucessoPacote}}</li>
            </ul>
        </div>
    </div>

    <div class="row" *ngIf="mensagemErroPacote?.length > 10">
        <div class="alert alert-danger alert-dismissible" style="width: 100%">
            <a class="close" data-bs-dismiss="alert" (click)="mensagemErroPacote = ''" aria-label="close">&times;</a>
            <ul>
                <li>{{mensagemErroPacote}}</li>
            </ul>
        </div>
    </div>
</ng-container>

<!-- Template para o modal de reserva de pacote -->
<ng-template #tplReservaPacote>
    <app-reserva-pacote [Pacote]="pacoteReserva" (alterou)="atualizarPacoteReserva($event)">
    </app-reserva-pacote>
</ng-template>

<!-- Template para o modal de cancelamento de pacote -->
<ng-template #tplCancelaPacote>
    <app-cancela-pacote [Pacote]="pacoteReserva" (alterou)="atualizarPacoteReserva($event)">
    </app-cancela-pacote>
</ng-template>

<!-- Modais utilizando os templates -->
<app-modal #modalReserva [modalConfig]="{modalTitle: 'Reservar Pacote', hideDismissButton: true, hideCloseButton: true}"
    [template]="tplReservaPacote">
</app-modal>

<app-modal #modalCancela [modalConfig]="{modalTitle: 'Cancelar Pacote', hideCloseButton: true, hideDismissButton: true}"
    [template]="tplCancelaPacote">
</app-modal>